import "./App.css";
import UserTable from "./UserTable";

function App() {
  return (
    <div className="App">
      <UserTable></UserTable>
    </div>
  );
}

export default App;
